export default function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// /home/riforce/domains/riforce.nl/releases/20250205091926/node_modules/@popperjs/core/lib/utils/expandToHashMap.js
// module id = 37
// module chunks = 0